import {LandingImage} from "./LandingImage/LandingImage";
import {BestDeals} from "./BestDeals/BestDeals";
import {Catagorical} from "./Catagorical/Catagorical";

export const LandingPage = () => {
  return (
    <div>
      <LandingImage />
      <BestDeals />
      <Catagorical />
    </div>
  );
};
